export const SOCIAL_LINKS = [
    {
        name: 'linkedin',
        link: 'https://www.linkedin.com/company/auckland-unlimited'
    },
];
